import React, { useState, useRef } from "react"
import classNames from "classnames"
import ss from "../styles/components/SortBar.module.scss"
import { useDispatch } from "react-redux"
import { setActiveSort } from "../actions/sort"

function SortBar(props) {
  const [show, setShow] = useState(false)
  const content = useRef()

  const sortTypes = ["популярности", "цене", "алфавиту"]

  function showMenu() {
    if (!show) {
      setShow(true)
      document.addEventListener("click", hideMenu)
    } else {
      setShow(false)
      document.removeEventListener("click", hideMenu)
    }
  }

  function hideMenu(event) {
    if (content.current && !content.current.contains(event.target)) {
      setShow(false)
      document.removeEventListener("click", hideMenu)
    }
  }

  const buttons = sortTypes.map((e, i) => <SortBtn key={i} name={e} index={i} activeSort={props.activeSort} />)

  const contentClass = classNames(ss.dropdown_content, { [ss.show]: show })

  return (
    <div className={ss.dropdown_wrapper}>
      Сортировка по:
      <div ref={content} className={ss.dropdown}>
        <button onClick={showMenu} className={ss.dropbtn}>
          {sortTypes[props.activeSort]}
        </button>
        <div className={contentClass}>{buttons}</div>
      </div>
    </div>
  )
}

function SortBtn(props) {
  const dispatch = useDispatch()

  return (
    <button
      className={ss.sort_btn}
      disabled={props.activeSort === props.index}
      onClick={() => dispatch(setActiveSort(props.index))}
    >
      {props.name}
    </button>
  )
}

export default SortBar
